import { jsx as _jsx } from "react/jsx-runtime";
import Layout from "./components/Layout";
import AppRoutes from "./router";
export default function App() {
    return (_jsx(Layout, { children: _jsx(AppRoutes, {}) }));
}
